import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var BellOff = createReactComponent("BellOff", ["svg", defaultAttributes, [["path", {
  d: "M13.73 21a2 2 0 01-3.46 0",
  key: "41ys2d"
}], ["path", {
  d: "M18.63 13A17.888 17.888 0 0118 8",
  key: "182lqt"
}], ["path", {
  d: "M6.26 6.26A5.86 5.86 0 006 8c0 7-3 9-3 9h14",
  key: "1xmazw"
}], ["path", {
  d: "M18 8a6 6 0 00-9.33-5",
  key: "1b66x3"
}], ["path", {
  d: "M2 2l20 20",
  key: "131xdx"
}]]]);
export default BellOff;